var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSocialMediaFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12.5 23.5h-11a1 1 0 0 1-1-1v-21a1 1 0 0 1 1-1h21a1 1 0 0 1 1 1v21a1 1 0 0 1-1 1h-6v-9h2.559a.5.5 0 0 0 .5-.438l.375-3a.5.5 0 0 0-.5-.562H16.5V9.185A1.687 1.687 0 0 1 18.186 7.5H20a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5h-1.814A5.69 5.69 0 0 0 12.5 9.185V10.5H10a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h2.5z"
})));
export { SvgIconSocialMediaFacebook as ReactComponent };